import { Environment } from '@lfg/core/enums';
import { Address } from 'viem';
import { mainnet, sepolia } from 'viem/chains';

export const APP_ENV = import.meta.env.VITE_APP_ENV as Environment;
export const API_URL = import.meta.env.VITE_API_URL;
export const ALCHEMY_KEY = import.meta.env.VITE_ALCHEMY_KEY;
export const WC_PROJECT_ID = import.meta.env.VITE_WC_PROJECT_ID;
export const WC_PROJECT_NAME = import.meta.env.VITE_WC_PROJECT_NAME;
export const REVERSE_PROXY_IP = import.meta.env.VITE_REVERSE_PROXY_IP;
export const PROJECT_CREATOR_ROLE = import.meta.env.VITE_PROJECT_CREATOR_ROLE;
export const TESTNET_SALE_FACTORY_ADDRESS = import.meta.env.VITE_TESTNET_SALE_FACTORY_ADDRESS as Address;
export const MAINNET_SALE_FACTORY_ADDRESS = import.meta.env.VITE_MAINNET_SALE_FACTORY_ADDRESS as Address;
export const TESTNET_USDT_ADDRESS = import.meta.env.VITE_TESTNET_USDT_ADDRESS as Address;
export const TESTNET_USDC_ADDRESS = import.meta.env.VITE_TESTNET_USDC_ADDRESS as Address;
export const TESTNET_GALA_ADDRESS = import.meta.env.VITE_TESTNET_GALA_ADDRESS as Address;
export const MAINNET_USDT_ADDRESS = import.meta.env.VITE_MAINNET_USDT_ADDRESS as Address;
export const MAINNET_USDC_ADDRESS = import.meta.env.VITE_MAINNET_USDC_ADDRESS as Address;
export const MAINNET_GALA_ADDRESS = import.meta.env.VITE_MAINNET_GALA_ADDRESS as Address;

export const WHITELIST_CREATOR_ADDRESS = import.meta.env.VITE_WHITELIST_CREATOR_ADDRESS as Address;

export const TESTNET_CHAIN_ID = sepolia.id;
export const MAINNET_CHAIN_ID = APP_ENV !== Environment.PROD ? sepolia.id : mainnet.id;

export const THRESHOLD = import.meta.env.VITE_THRESHOLD;
export const MAX_THRESHOLD = import.meta.env.VITE_MAX_THRESHOLD ?? 2_000_000_000;
export const TIMEFRAME = import.meta.env.VITE_TIMEFRAME;

export const GA_ID = import.meta.env.VITE_GA_ID;
